import React, { useState } from 'react';

const DAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

function getDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}

function getFirstDayOfMonth(year, month) {
  const day = new Date(year, month, 1).getDay();
  return day === 0 ? 6 : day - 1; // Пн = 0
}

export default function DatePicker({ value, onChange, onClose }) {
  const today = new Date();
  const [viewDate, setViewDate] = useState(() => {
    if (value) {
      const [y, m] = value.split('-').map(Number);
      return new Date(y, m - 1, 1);
    }
    return new Date(today.getFullYear(), today.getMonth(), 1);
  });

  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();
  const daysInMonth = getDaysInMonth(year, month);
  const firstDay = getFirstDayOfMonth(year, month);

  const selectedDate = value ? new Date(value + 'T00:00:00') : null;

  const prevMonth = () => setViewDate(new Date(year, month - 1, 1));
  const nextMonth = () => setViewDate(new Date(year, month + 1, 1));

  const selectDay = (day) => {
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    onChange(dateStr);
    onClose();
  };

  const monthNames = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
  ];

  // Формат ДД.ММ.ГГГГ для отображения
  const formatDisplay = (dateStr) => {
    if (!dateStr) return 'Выберите дату';
    const [y, m, d] = dateStr.split('-');
    return `${d}.${m}.${y}`;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/40" onClick={onClose}>
      <div
        className="w-full max-w-md rounded-t-2xl bg-white p-4 shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        {/* Заголовок */}
        <div className="mb-3 flex items-center justify-between">
          <button onClick={prevMonth} className="p-2 text-[#64748b] hover:text-[#0f172a]">
            ←
          </button>
          <span className="text-sm font-semibold text-[#0f172a]">
            {monthNames[month]} {year}
          </span>
          <button onClick={nextMonth} className="p-2 text-[#64748b] hover:text-[#0f172a]">
            →
          </button>
        </div>

        {/* Дни недели */}
        <div className="mb-1 grid grid-cols-7 gap-1">
          {DAYS.map(d => (
            <div key={d} className="text-center text-[10px] font-medium text-[#64748b]">
              {d}
            </div>
          ))}
        </div>

        {/* Дни */}
        <div className="grid grid-cols-7 gap-1">
          {Array.from({ length: firstDay }, (_, i) => (
            <div key={`empty-${i}`} />
          ))}
          {Array.from({ length: daysInMonth }, (_, i) => {
            const day = i + 1;
            const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            const isSelected = selectedDate && dateStr === value;
            const isToday = dateStr === `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

            return (
              <button
                key={day}
                onClick={() => selectDay(day)}
                className={`h-9 w-full rounded-lg text-sm transition ${
                  isSelected
                    ? 'bg-[#374151] text-white font-semibold'
                    : isToday
                    ? 'bg-[#374151]/10 text-[#374151] font-medium'
                    : 'text-[#0f172a] hover:bg-[#f1f5f9]'
                }`}
              >
                {day}
              </button>
            );
          })}
        </div>

        {/* Кнопки */}
        <div className="mt-3 flex gap-2">
          <button
            onClick={() => { onChange(''); onClose(); }}
            className="flex-1 rounded-xl border border-[#e2e8f0] bg-white py-2.5 text-sm text-[#64748b] transition hover:bg-[#f8fafc]"
          >
            Сбросить
          </button>
          <button
            onClick={onClose}
            className="flex-1 rounded-xl bg-[#374151] py-2.5 text-sm text-white transition hover:bg-[#1f2937]"
          >
            Готово
          </button>
        </div>
      </div>
    </div>
  );
}
